import React from "react";
import PerformanceTable from "./components/PerformanceTable";
import PortfolioConfigData from "config/portfolio-config.json";
import styles from "pages/assistant/components/artifacts/components/fineco-portfolio/finecoPortfolio.common.module.scss";
import { useTranslation } from "react-i18next";
import MatriceDiCorrelazione1y from "./components/MatriceDiCorrelazione1y";

type SectionChildrenProps = { reportData: any; reportData2?: any };
const AnalisiStrumentiContainer: React.FC<SectionChildrenProps> = ({
  reportData,
  reportData2,
}) => {
  const { t } = useTranslation();
  if (!reportData) {
    return <></>;
  }
  const configData = PortfolioConfigData.analisi_strumenti.data;

  const matriceData = {
    data: reportData.analisi_strumenti.matrice_di_correlazione_1y,
    isin: reportData.analisi_strumenti.matrice_di_correlazione_1y_isin,
    legend: reportData.analisi_strumenti.matrice_di_correlazione_1y_legend,
  };
  let matriceData2 = null;
  if (reportData2) {
    matriceData2 = {
      data: reportData2.analisi_strumenti.matrice_di_correlazione_1y,
      isin: reportData2.analisi_strumenti.matrice_di_correlazione_1y_isin,
      legend: reportData2.analisi_strumenti.matrice_di_correlazione_1y_legend,
    };
  }

  return (
    <>
      {!reportData2 && (
        <div style={{ marginBottom: 10, marginLeft: 5 }}>
          <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
            {configData.performance_strumenti_fondi_etf.label}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf:
                reportData.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari:
                reportData.analisi_strumenti
                  .performance_strumenti_obbligazionari,
              configData: { type: "table_simple" },
            }}
          />
          <div className={styles.subSectionTitle} style={{ marginTop: 6 }}>
            {t("portfolio.matriceDiCorrelazione1y")}
          </div>
          <MatriceDiCorrelazione1y dataObject={matriceData} />
        </div>
      )}
      {reportData2 && (
        <div style={{ marginBottom: 0, marginLeft: 5 }}>
          <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
            {configData.performance_strumenti_fondi_etf.label +
              " " +
              t("portafoglioCompare.portafoglio1")}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf:
                reportData.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari:
                reportData.analisi_strumenti
                  .performance_strumenti_obbligazionari,
              configData: { type: "table_simple" },
            }}
          />
          <div className="force-page-break"></div>
          <div className={styles.subSectionTitle} style={{ marginTop: 35 }}>
            {configData.performance_strumenti_fondi_etf.label +
              " " +
              t("portafoglioCompare.portafoglio2")}
          </div>
          <PerformanceTable
            dataObject={{
              strumenti_fondi_etf:
                reportData2.analisi_strumenti.performance_strumenti_fondi_etf,
              strumenti_obbligazionari:
                reportData2.analisi_strumenti
                  .performance_strumenti_obbligazionari,
              configData: { type: "table_simple" },
            }}
          />
          <div className="force-page-break"></div>
          <div className={styles.subSectionTitle} style={{ marginTop: 6 }}>
            {t("portfolio.matriceDiCorrelazione1y") +
              " " +
              t("portafoglioCompare.portafoglio1")}
          </div>
          <MatriceDiCorrelazione1y dataObject={matriceData} />
          <div className="force-page-break"></div>
          <div className={styles.subSectionTitle} style={{ marginTop: 16 }}>
            {t("portfolio.matriceDiCorrelazione1y") +
              " " +
              t("portafoglioCompare.portafoglio2")}
          </div>
          <MatriceDiCorrelazione1y dataObject={matriceData2} />
        </div>
      )}
    </>
  );
};
export default React.memo(
  AnalisiStrumentiContainer,
  (prevProps: SectionChildrenProps, nextProps: SectionChildrenProps) => {
    return prevProps.reportData === nextProps.reportData;
  },
);
